export const GET_EMPLOYEE_SECTION = {
  INITIATE: 'GET_EMPLOYEE_SECTION_INITIATE',
  SUCCESS: 'GET_EMPLOYEE_SECTION_SUCCESS',
  FAILED: 'GET_EMPLOYEE_SECTION_FAILED',
};

export const GET_EMPLOYEES = {
  INITIATE: 'GET_EMPLOYEES_INITIATE',
  SUCCESS: 'GET_EMPLOYEES_SUCCESS',
  FAILED: 'GET_EMPLOYEES_FAILED',
};

export const GET_EMPLOYEES_FOR_GROUP = {
  INITIATE: 'GET_EMPLOYEES_FOR_GROUP_INITIATE',
  SUCCESS: 'GET_EMPLOYEES_FOR_GROUP_SUCCESS',
  FAILED: 'GET_EMPLOYEES_FOR_GROUP_FAILED',
};

export const REMOVE_EMPLOYEE_FROM_COMPANY = {
  INITIATE: 'REMOVE_EMPLOYEE_FROM_COMPANY_INITIATE',
  SUCCESS: 'REMOVE_EMPLOYEE_FROM_COMPANY_SUCCESS',
  FAILED: 'REMOVE_EMPLOYEE_FROM_COMPANY_FAILED',
};

export const UPLOAD_EMPLOYEES = {
  INITIATE: 'UPLOAD_EMPLOYEES_INITIATE',
  SUCCESS: 'UPLOAD_EMPLOYEES_SUCCESS',
  FAILED: 'UPLOAD_EMPLOYEES_FAILED',
  CLEAR: 'UPLOAD_EMPLOYEES_CLEAR',
};

export const GET_UPLOAD_STATUS = {
  INITIATE: 'GET_UPLOAD_STATUS_INITIATE',
  SUCCESS: 'GET_UPLOAD_STATUS_SUCCESS',
  FAILED: 'GET_UPLOAD_STATUS_FAILED',
  CLEAR: 'GET_UPLOAD_STATUS_CLEAR',
};

export const GET_EMPLOYEE_DETAILS = {
  INITIATE: 'GET_EMPLOYEE_DETAILS_INITIATE',
  SUCCESS: 'GET_EMPLOYEE_DETAILS_SUCCESS',
  FAILED: 'GET_EMPLOYEE_DETAILS_FAILED',
};

export const GET_EMPLOYEE_CREDIT_TRANSACTIONS = {
  INITIATE: 'GET_EMPLOYEE_CREDIT_TRANSACTIONS_INITIATE',
  SUCCESS: 'GET_EMPLOYEE_CREDIT_TRANSACTIONS_SUCCESS',
  FAILED: 'GET_EMPLOYEE_CREDIT_TRANSACTIONS_FAILED',
};

export const GET_EMPLOYEE_STATUS = {
  INITIATE: 'GET_EMPLOYEE_STATUS_INITIATE',
  SUCCESS: 'GET_EMPLOYEE_STATUS_SUCCESS',
  FAILED: 'GET_EMPLOYEE_STATUS_FAILED',
};

export const UPSERT_EMPLOYEE = {
  INITIATE: 'UPSERT_EMPLOYEE_INITIATE',
  SUCCESS: 'UPSERT_EMPLOYEE_SUCCESS',
  FAILED: 'UPSERT_EMPLOYEE_FAILED',
};

export const GET_EMPLOYEE_CONSUMPTIONS = {
  INITIATE: 'GET_EMPLOYEE_CONSUMPTIONS_INITIATE',
  SUCCESS: 'GET_EMPLOYEE_CONSUMPTIONS_SUCCESS',
  FAILED: 'GET_EMPLOYEE_CONSUMPTIONS_FAILED',
};

export const SET_UPLOAD_MSG = 'SET_UPLOAD_MSG';

export const upsertEmployeeInitiate = payload => ({
  type: UPSERT_EMPLOYEE.INITIATE,
  payload,
});

export const upsertEmployeeFailed = err => ({
  type: UPSERT_EMPLOYEE.FAILED,
  err,
});

export const upsertEmployeeSuccess = () => ({
  type: UPSERT_EMPLOYEE.SUCCESS,
});

export const getEmployeeSectionDataInitiate = payload => ({
  type: GET_EMPLOYEE_SECTION.INITIATE,
  payload,
});

export const getEmployeeSectionDataFailed = err => ({
  type: GET_EMPLOYEE_SECTION.FAILED,
  err,
});

export const getEmployeeSectionDataSuccess = employeeSection => ({
  type: GET_EMPLOYEE_SECTION.SUCCESS,
  employeeSection,
});

export const getAllEmployeesInitiate = payload => ({
  type: GET_EMPLOYEES.INITIATE,
  payload,
});

export const getAllEmployeesFailed = err => ({
  type: GET_EMPLOYEES.FAILED,
  err,
});

export const getAllEmployeesSuccess = employeesData => ({
  type: GET_EMPLOYEES.SUCCESS,
  employeesData,
});

export const getEmployeesForGroupInitiate = payload => ({
  type: GET_EMPLOYEES_FOR_GROUP.INITIATE,
  payload,
});

export const getEmployeesForGroupFailed = err => ({
  type: GET_EMPLOYEES_FOR_GROUP.FAILED,
  err,
});

export const getEmployeesForGroupSuccess = groupEmployees => ({
  type: GET_EMPLOYEES_FOR_GROUP.SUCCESS,
  groupEmployees,
});

export const uploadEmployeesInitiate = payload => ({
  type: UPLOAD_EMPLOYEES.INITIATE,
  payload,
});

export const uploadEmployeesFailed = err => ({
  type: UPLOAD_EMPLOYEES.FAILED,
  err,
});

export const uploadEmployeesSuccess = processId => ({
  type: UPLOAD_EMPLOYEES.SUCCESS,
  processId,
});

export const uploadEmployeesClear = () => ({
  type: UPLOAD_EMPLOYEES.CLEAR,
});

export const setUploadMsg = payload => ({
  type: SET_UPLOAD_MSG,
  uploadMsg: payload,
});

export const getUploadStatusInitiate = payload => ({
  type: GET_UPLOAD_STATUS.INITIATE,
  payload,
});

export const getUploadStatusFailed = err => ({
  type: GET_UPLOAD_STATUS.FAILED,
  err,
});

export const getUploadStatusSuccess = uploadStatusData => ({
  type: GET_UPLOAD_STATUS.SUCCESS,
  uploadStatusData,
});

export const getEmployeeDetailsInitiate = payload => ({
  type: GET_EMPLOYEE_DETAILS.INITIATE,
  payload,
});

export const getEmployeeDetailsFailed = err => ({
  type: GET_EMPLOYEE_DETAILS.FAILED,
  err,
});

export const getEmployeeDetailsSuccess = employeeData => ({
  type: GET_EMPLOYEE_DETAILS.SUCCESS,
  employeeData,
});

export const getEmployeeCreditTransactionsInitiate = payload => ({
  type: GET_EMPLOYEE_CREDIT_TRANSACTIONS.INITIATE,
  payload,
});

export const getEmployeeCreditTransactionsFailed = err => ({
  type: GET_EMPLOYEE_CREDIT_TRANSACTIONS.FAILED,
  err,
});

export const getEmployeeCreditTransactionsSuccess = creditTransactions => ({
  type: GET_EMPLOYEE_CREDIT_TRANSACTIONS.SUCCESS,
  creditTransactions,
});

export const getEmployeeStatusInitiate = payload => ({
  type: GET_EMPLOYEE_STATUS.INITIATE,
  payload,
});

export const getEmployeeStatusFailed = err => ({
  type: GET_EMPLOYEE_STATUS.FAILED,
  err,
});

export const getEmployeeStatusSuccess = employeeStatus => ({
  type: GET_EMPLOYEE_STATUS.SUCCESS,
  employeeStatus,
});

export const removeEmployeeFromCompanyInitiate = payload => ({
  type: REMOVE_EMPLOYEE_FROM_COMPANY.INITIATE,
  payload,
});

export const removeEmployeeFromCompanySuccess = removedEmployeeStatus => ({
  type: REMOVE_EMPLOYEE_FROM_COMPANY.SUCCESS,
  removedEmployeeStatus,
});

export const removeEmployeeFromCompanyFailed = err => ({
  type: REMOVE_EMPLOYEE_FROM_COMPANY.FAILED,
  err,
});

export const getEmployeeConsumptionsInitiate = payload => ({
  type: GET_EMPLOYEE_CONSUMPTIONS.INITIATE,
  payload,
});

export const getEmployeeConsumptionsFailed = err => ({
  type: GET_EMPLOYEE_CONSUMPTIONS.FAILED,
  err,
});

export const getEmployeeConsumptionsSuccess = ordersData => ({
  type: GET_EMPLOYEE_CONSUMPTIONS.SUCCESS,
  ordersData,
});
